import { memo } from "react"
import styled from "styled-components"

const ControlSafe = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

const IconCaretDownGray = () => {
  return (
    <ControlSafe>
      <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.5857 0.525391L1.41412 0.525391C0.523211 0.525391 0.077042 1.60253 0.707007 2.2325L6.2928 7.81828C6.68332 8.20881 7.31648 8.20881 7.70701 7.81828L13.2928 2.2325C13.9228 1.60253 13.4766 0.525391 12.5857 0.525391Z"
          fill="#646464"
        />
      </svg>
    </ControlSafe>
  )
}

export default memo(IconCaretDownGray)
